import React from 'react'
import DocumentHeadTags from 'components/document-head-tags'
import styles from './index.module.css'

type Props = {
  helmet?: string
  title: string
  children: React.ReactNode
}

/**
 * Login message wrapper component with DISCO branding and document head management
 * Provides consistent layout for login-related messages and pages
 * @param helmet - Additional text for document title
 * @param title - Main title text to display
 * @param children - Content to render below the title
 */
const LoginMessage = ({
  helmet,
  title,
  children,
}: Props): React.ReactElement<'div'> => {
  return (
    <div className={styles.loginMessageWrapper}>
      <DocumentHeadTags title={`${helmet ? helmet + ' | ' : ''} DISCO`} />
      <div className={styles.loginMessage}>
        <div className={styles.loginMessageLogo} />

        <div className={styles.loginMessageTitleContainer}>
          <h2 className={styles.loginMessageText}>{title}</h2>
        </div>
        {children}
      </div>
    </div>
  )
}

export default LoginMessage
